import {
  compose,
  map,
  pathOr,
  prop,
} from 'ramda'

export const unwrapPath = (path) => compose(map(prop('node')), pathOr([], path))

export const liftEdges = (field) => pathOr([], [field, 'edges'])

export const unwrapNodes = unwrapPath(['edges'])
